import React, { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { CopyableValue } from "src/shared/components/CopyableValue";

export interface IFormatterProps {
  children: any;
  value?: any;
  notApplicable?: ReactNode;
  isCopyable?: boolean;
}

export const Formatter = ({
  children,
  value,
  notApplicable = "-",
  isCopyable,
}: IFormatterProps) => {
  const valueToCompare = value !== undefined ? value : children;
  if (
    valueToCompare === null ||
    valueToCompare === undefined ||
    (typeof valueToCompare === "string" && valueToCompare.trim().length === 0)
  ) {
    return <span className="na">{notApplicable}</span>;
  }

  if (valueToCompare === true) {
    return <FormattedMessage id="ui.true" />;
  } else if (valueToCompare === false) {
    return <FormattedMessage id="ui.false" />;
  }

  if (isCopyable) {
    return (
      <CopyableValue copyValue={valueToCompare.toString()}>
        {children}
      </CopyableValue>
    );
  } else {
    return children;
  }
};
